import { render, staticRenderFns } from "./AlertDence.vue?vue&type=template&id=d0b866d8"
import script from "./AlertDence.vue?vue&type=script&lang=js"
export * from "./AlertDence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports